import { Button, Grid, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import show from "../../../api/auth/orders/show";
import OrderForm from "../../../components/form/orders/OrderForm";
import useOrderStore from "../../../stores/useOrderStore";
import WushCard from "../../../components/layout/WushCard";
import OrderSummary from "../../../components/displays/orders/OrderSummary";
import OrderReview from "../../../components/displays/orders/OrderReview";
import index from "../../../api/auth/orders";
import PageLoading from "../../../components/layout/PageLoading";
import DeleteConfirmation from "../../../components/form/DeleteConfirmation";
import { Delete } from "@mui/icons-material";
import destroy from "../../../api/auth/orders/destroy";
import useAlertStore from "../../../stores/useAlertStore";

export default function Order() {
  const { updateOrder, orderById, orders, setOrders, removeOrder, addOrder } = useOrderStore();
  const { setAlertMessage } = useAlertStore();

  const { id } = useParams();

  const order = orderById(id);

  const navigate = useNavigate();

  useEffect(() => {
    if(orders.length === 0) {
      index((response) => {
        setOrders(response);
        setTimeout(() => {
          show(id, (response) => {
            orderById(id) ? updateOrder(response) : addOrder(response);
          });
        }, 100);
      }, () => {
        setAlertMessage('Failed to prepopulate orders, please refresh!', 'error');
      });
    } else {
      show(id, (response) => {
        orderById(id) ? updateOrder(response) : addOrder(response);
        updateOrder(response);
      }, () => {
        setAlertMessage('Failed to load orders!', 'error');
      });
    }
  }, []);

  const handleDelete = () => {
    destroy(id, () => {
      removeOrder(order);
      setAlertMessage('Order deleted successfully');
      navigate('/orders');
    });
  };

  if(!order) return <PageLoading />;

  return (
    <Stack>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={ ['paid', 'cancelled'].includes(order.status) ? 12 : 7 }>
          {['paid', 'cancelled'].includes(order.status) ? <OrderReview order={order} /> : <OrderForm order={order} />}
        </Grid>
        {!['paid', 'cancelled'].includes(order.status) &&
          <Grid item xs={12} sm={4} position={{ sm: "fixed" }} right={0} pr={2} height={{ sm: "90vh" }} overflow={{ sm: "scroll" }}>
            {order.deletable && <Stack direction="row" width="100%" justifyContent="right" mb={2}>
              <DeleteConfirmation
                handleDelete={handleDelete}
              >
                <Button variant="contained" color="error">
                  <Stack direction="row" spacing={1}>
                    <Delete />
                    <Typography>Delete Order</Typography>
                  </Stack>
                </Button>
              </DeleteConfirmation>
            </Stack>}
            <WushCard>
              <Stack p={2}>
                <OrderSummary order={order} />
              </Stack>
            </WushCard>
          </Grid>
        }
      </Grid>
    </Stack>
  );
}